import { setRoutes, changeRoute } from '../actions';
import PropTypes from 'prop-types';

class Router extends React.PureComponent {
  constructor(props) {
    super(props);

    window.addEventListener('hashchange', event => {
      const hash = event.newURL.split('#')[1];
      props.actions.changeRoute(hash);
    });
  }

  static defaultProps = {
    className: '',
  };

  static propTypes = {
    children: PropTypes.array.isRequired,
    className: PropTypes.string,
    home: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { actions, hash, home, path } = this.props;

    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
    const routes = children.map(item => item.props.path);

    if (routes.length === 0) {
      console.error('Router must have at least one Route');
    }

    actions.setRoutes(routes);

    if (!hash || !routes.includes(path)) {
      window.location.hash = home;
    }
  }

  componentWillUnmount() {
    window.onhashchange = null;
  }

  render() {
    const { className, path } = this.props;

    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
    const component = children.filter(item => {
      return item.props.path === path;
    })[0];

    if (!component) {
      console.warn(`No such path ${path} was found in routes definition, returning to default route`);
      return null;
    }

    return <div className={`Edocat-Router ${className}`}>{component}</div>;
  }
}

export const mapStateToProps = (state, props) => ({
  ...state.navigation,
  children: Array.isArray(props.children) ? props.children : [props.children],
});

export const mapDispatchToProps = dispatch => ({
  actions: redux.bindActionCreators({ setRoutes, changeRoute }, dispatch),
});

export default reactRedux.connect(mapStateToProps, mapDispatchToProps)(Router);
